import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import { QuestionInputTypes } from '../form';
export var Category = t.type({
  name: t.string
});
export var Image = t.type({
  id: t.string,
  blurhash: t.string
});
export var Reward = t.type({
  __typename: t.literal('Reward'),
  id: t.string,
  category: Category,
  featured: t["boolean"],
  name: t.string,
  image: nullable(Image),
  points: t.number,
  questions: nullable(t.array(QuestionInputTypes.Question)),
  description: t.string,
  disclaimer: nullable(t.string),
  onWishList: t["boolean"],
  perksCount: t.number,
  requiresShippingAddress: t["boolean"]
});
var Error = t.type({
  message: t.string
});
var RewardWishlistOutput = t.union([t.type({
  __typename: t.literal('RewardWishlistErrors'),
  errors: t.array(Error)
}), t.type({
  __typename: t.literal('RewardWishlistResult'),
  reward: t.type({
    id: t.string,
    onWishList: t["boolean"]
  })
})]);
export var RemoveRewardFromWishlistOutput = t.type({
  removeRewardFromWishlist: RewardWishlistOutput
});
export var AddRewardToWishlistOutput = t.type({
  addRewardToWishlist: RewardWishlistOutput
});
export var WishlistMutationInput = t.type({
  id: t.string
});